import React from 'react';

import { theme } from 'theme';

import { Typography } from './Typography';

export function BetaTag({ white }: { white?: boolean }) {
  return (
    <Typography
      style={{
        color: white ? 'white' : theme.colors.primary[700],
        marginRight: 0,
        marginLeft: '4px',
        fontSize: '0.6em',
        fontWeight: 'bold',
        verticalAlign: 'top',
        marginTop: '-0.6em',
      }}
    >
      BETA
    </Typography>
  );
}
